export default "__VITE_ASSET__BDGwzWN6__"